import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/research-icon.svg'


const _hoisted_1 = { class: "background w-screen flex items-center justify-center flex-col h-screen fixed top-0 left-0" }
const _hoisted_2 = { class: "box-complete-items-msg flex flex-col md:flex-row space-y-4 md:space-x-8 justify-center items-center md:items-start pb-8" }
const _hoisted_3 = {
  class: "w-full h-[95vh]",
  style: {"max-width":"1060px"}
}
const _hoisted_4 = { class: "bg-white rounded-lg p-8 flex flex-col justify-start border-b-4 h-full border-h-primary-500 mt-4" }
const _hoisted_5 = { class: "flex flex-col md:flex-row space-x-0 md:space-x-8 items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "mt-8 md:mt-0" }
const _hoisted_8 = { class: "flex justify-between flex-row space-x-2 items-center" }
const _hoisted_9 = { class: "flex flex-row space-x-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_11 = { class: "flex flex-row items-center justify-between" }
const _hoisted_12 = { class: "text-h-primary-500" }
const _hoisted_13 = { class: "flex flex-row" }
const _hoisted_14 = { class: "w-full md:w-[85%] mt-8 min-w-[300px]" }
const _hoisted_15 = { class: "survey overflow-auto mt-8" }
const _hoisted_16 = { class: "h-[90%] mt-4 pr-4" }
const _hoisted_17 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "mt-4 text-h-error-400 text-[12px]"
}
const _hoisted_21 = { class: "mt-12" }
const _hoisted_22 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.homeroAvatar,
              class: "avatar-homero mt-6",
              alt: ""
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.$t("labels.generic", {
                          pt: "Pesquisa",
                          en: "Survey",
                        })), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_MessageVoice, {
                        msg: "Parabéns, você finalizou todo o objetivo ! Para melhorarmos ainda mais nosso conteúdo, pedimos por favor que classifique as afirmações abaixo em uma escala de 1 (Discordo totalmente) a 5 (Concordo totalmente).",
                        scaleIcons: 0.8,
                        showIconsName: false
                      }, null, 8, ["scaleIcons"])
                    ])
                  ])
                ]),
                _createVNode(_component_Button, {
                  class: _normalizeClass(`${
                    _ctx.surveyComplete ? 'btn-primary' : 'btn-disabled'
                  }  rounded-md w-[100px] h-[50px] flex justify-center`),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sendFeedback()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "Enviar", en: "Send" })), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("p", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Parabéns, você finalizou todo o objetivo ! Para melhorarmos ainda mais nosso conteúdo, pedimos por favor que classifique as afirmações abaixo em uma escala de",
                    en: "Congratulations, you have completed the entire objective ! To further improve our content, please rate the statements below on a scale of",
                  })) + " ", 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "1 (Discordo totalmente) a 5 (Concordo totalmente).",
                      en: "1 (Strongly Disagree) to 5 (Strongly Agree).",
                    })), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.survey, (statement) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: statement,
                  class: _normalizeClass(`mb-8 ${
                  statement.answered === false
                    ? 'border-2 border-red-500 p-2 rounded-md'
                    : ''
                }`)
                }, [
                  _createElementVNode("p", null, _toDisplayString(statement.prompt), 1),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                      return _createElementVNode("button", {
                        key: index,
                        class: _normalizeClass(`space-y-2 border-2 ${
                      statement.rate == index
                        ? 'bg-yellow-100 border-yellow-600'
                        : 'btn-h-info'
                    } p-2 rounded-md shadow-md`),
                        onClick: ($event: any) => {
                      statement.rate = index;
                      statement.answered = true;
                    }
                      }, [
                        _createElementVNode("img", {
                          src: 
                        require('@/assets/images/emojis/emoji-' +
                          index +
                          '.svg')
                      ,
                          alt: "emojis"
                        }, null, 8, _hoisted_19),
                        _createElementVNode("p", null, _toDisplayString(index), 1)
                      ], 10, _hoisted_18)
                    }), 64))
                  ]),
                  (statement.answered === false)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Campo obrigatório",
                      en: "Required field",
                    })), 1))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Como tem sido a sua experiência geral com a plataforma? Deseja fazer algum comentário, como elogio ou sugestão? (Opcional)",
                      en: "How has your overall experience with the platform been? wish make a comment, like a compliment or a suggestion? (Optional)",
                    })), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_Textarea, {
                    modelValue: _ctx.comment,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.comment) = $event)),
                    rows: "5",
                    maxlength: "500"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}